/*global angular */

(function (angular) {
'use strict';

var dirs = angular.module('adminHelper.directives', []);

var $injector = angular.injector(['ng', 'readly.services']),
    template = $injector.get('template');


dirs.directive('helperPaginator', function () {
    var getPages = function (scope) {
            var left = scope.curPage - scope.pagesRange + 1,
                right = scope.curPage + scope.pagesRange,
                range;

            scope.left = left < 1 ? 1 : left;
            scope.right = right > scope.numPages ? scope.numPages : right;

            range = scope.right - scope.left >= 0 ? scope.right - scope.left + 1 : 0;
            return Array.apply(null, Array(range)).map(function (_, i) {return scope.left + i;}); // jshint ignore:line
        },

        render = function (scope) {
            scope.numPages = Math.ceil(scope.num / scope.perPage) || 1;
            scope.pages = getPages(scope);
        };

    return {
        restrict: 'AE',
        scope: {
            num: '=',
            perPage: '=',
            curPage: '=',
            pagesRange: '=?',
            getPageUrl: '&getPageUrl'
        },
        templateUrl: template.url('admin-helper', 'paginator.html'),
        link: function (scope, element, attrs) {

            scope.pageUrl = scope.getPageUrl();

            scope.pagesRange = scope.pagesRange || 5;

            render(scope);
            scope.$watchCollection('[num, curPage]', function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    render(scope);
                }
            });
        }
    };
});


}(angular));
